import React from 'react';
import { useParams } from 'react-router-dom';
import DynamicJEEAdvTest from './DynamicJEEAdvTest';
import { freeAdvTestsMetadata } from '../../../data/freeADVTestData';

export default function FreeAdvTest() {

  return   <DynamicJEEAdvTest testsMetadata={freeAdvTestsMetadata} />
}
